export const INTEGRITY_CHECK_FORM_FOOTER = {
  partner: {
    website: 'https://www.psafe.com/pt-br/dfndr-security/',
    label: 'Ir para página do parceiro dfndr security, abre nova guia em página externa',
  },
  images: {
    serasa: {
      source:
        'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2F762ff6496c3542eb9cc81b070151c237',
      width: 104,
      height: 45,
    },
    dfndr: {
      source:
        'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2Fea7feb675d2848a2b1512c9e6a622dde',
      width: 234,
      height: 60,
    },
  },
}
